import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useI18n } from '../../i18n';

export default function LanguageSwitcher({ size = 'small' }) {
  const { locale, setLocale } = useI18n();

  return (
    <ToggleButtonGroup
      size={size}
      exclusive
      value={locale}
      onChange={(_, v) => v && setLocale(v)}
      aria-label="Language"
      sx={{
        '& .MuiToggleButton-root': {
          px: 1.25,
          py: 0.25,
          fontWeight: 600,
          fontSize: '0.75rem',
          textTransform: 'none',
          borderColor: 'divider',
        },
      }}
    >
      <ToggleButton value="ko">KO</ToggleButton>
      <ToggleButton value="en">EN</ToggleButton>
    </ToggleButtonGroup>
  );
}
